import { useEffect, useState } from "react";
import { ModuleSampleVhr } from "@carfax/contentful/PageModularModule";
import { SampleVhrComponent } from "@carfax/web-ui/components/SampleVhr";
import { useStores } from "../../../hooks";
import { observer } from "app";
import { useTranslations } from "next-intl";
import { ButtonVariants } from "@carfax/web-ui/shared/Button";
import SampleReport from "components/SampleReport";
import RichTextWrapper from "../TextImage/components/RichTextWrapper";

interface SampleVhrProps {
  module: ModuleSampleVhr;
  showSecondaryImage: boolean;
}

const SampleVhr = observer(({ module, showSecondaryImage }: SampleVhrProps) => {
  "use no memo";
  const { browserStore } = useStores();
  const t = useTranslations("common");
  const [isDesktop, setIsDesktop] = useState(false);

  const primaryImage = isDesktop ? module.primaryDesktopImage : module.primaryMobileImage;
  const secondaryImage = isDesktop ? module.secondaryDesktopImage : module.secondaryMobileImage;

  const imageUrl = showSecondaryImage ? secondaryImage : primaryImage;

  useEffect(() => {
    setIsDesktop(browserStore.isDesktop);
  }, [browserStore.isDesktop]);

  return (
    <SampleVhrComponent
      imageSource={imageUrl}
      alt={module.primaryDesktopImage?.title ?? ""}
      title={module.title}
      text={<RichTextWrapper content={module.text} textAlign="left" />}
      isDesktop={isDesktop}
    >
      <SampleReport
        optionalDesktopReport={module.optionalDesktopReport}
        optionalMobileReport={module.optionalMobileReport}
        withButton={true}
        buttonText={t("vinWidget.sampleReportLink.text")}
        buttonVariant={ButtonVariants.Outlined}
      />
    </SampleVhrComponent>
  );
});

export default SampleVhr;
